<template>
  <div class="dashboard column">
    <Header />
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "Dashboard",
  components: {
    Header
  }
};
</script>


